import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import type { Config } from '..';
import content from '../../../../.contentlayer/generated/PrivacyPolicy/privacyPolicy__en-FR.mdx.json';

export const config: Config = {
  layout: { ...sharedConfig['en-FR'].layout },
  seo: {
    ...sharedConfig['en-FR'].seo,
    title: 'Privacy Policy • Lemonade Insurance FR',
    metaTitle: 'Privacy Policy • Lemonade Insurance FR',
    description:
      'Read Lemonade’s Privacy Policy for detailed information on how we collect, use, store, and protect your personal data when using our services.',
  },
  MDXContent: content as DocumentTypes,
};
